import { initializeAuctionManager, connectToHub } from '../../auction_manager';
import { AUCTION_EVENTS } from '../../event_bus_modules/auction_bidding';
import { getCookieByName } from '../../utils/cookies';

// we need to wait until window fully loaded to make sure that bidx1 hub script has been loaded
$(window).on('load', () => {
  const isAuction = $('input#_is-auction').val() === 'True';
  const auctionPropertyId = parseInt($('input#_entity-id').val());
  const auctionId = parseInt($('input#_auction-id').val());
  const userBidderId = parseInt($('input#_auction-bidder-id').val());
  const secondsToClosing = parseInt($('input#_seconds-to-closing').val());
  const secondsToAuctionStart = parseInt(
    $('input#_seconds-to-auction-start').val()
  );
  const isBiddingOpened = secondsToAuctionStart < 0 && secondsToClosing > 0;
  const isSidebarHidden = $('input#_show-side-bar').val() === 'False';
  const jwtToken = getCookieByName('jwt');

  const djangoLanguage = getCookieByName('django_language') || 'en';

  const auctionOptions = {
    auctionPropertyId,
    auctionId,
    userBidderId,
    jwtToken,
    djangoLanguage,
  };

  const isTwoHoursBeforeAuctionStarts =
    secondsToAuctionStart < 7200 && secondsToAuctionStart > 0;

  if (isAuction && isTwoHoursBeforeAuctionStarts) {
    connectToHub(auctionOptions);
  }

  if (isAuction && isBiddingOpened && !isSidebarHidden) {
    initializeAuctionManager(auctionOptions);
  }

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_TIME_STARTS, () => {
    $('.loader-layer').addClass('loader-layer--active');
    setTimeout(() => {
      window.location.reload(true);
    }, 2000);
  });
});

$(() => {
  const sidebarContent = $('#sidebar-content');
  const propertyDetailsRightColumn = $('#property-details #auction-details');

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_CLOSED, () => {
    propertyDetailsRightColumn.addClass('auction-ended');
    sidebarContent
      .find('.bidding-active')
      .removeClass('bidding-active')
      .addClass('auction-ended');
  });

  EVENT_BUS.on(AUCTION_EVENTS.AUCTION_TIME_STARTS, () => {
    sidebarContent.find('#opened-sidebar').addClass('bidding-active');
  });
});
